import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retriveProjectCreatorModelTemplate() {
      try {
        const structure = await axios.get('/projects-creator-model-template', { withCredentials: true });
        return structure.data;
      } catch (error) {
        throw error;
      }
    },
    async createProjectCreatorModelTemplate(context, data) {
      try {
        const config = { withCredentials: true };
        const response = await axios.post('/projects-creator-model-template', data, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async deleteProjectCreatorModelTemplate(context, type) {
      try {
        const config = { withCredentials: true };
        const response = await axios.delete(`/projects-creator-model-template/${type}`, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
